import { MockAuthProvider } from './MockAuthProvider';
import { MockTenantProvider } from './MockTenantProvider';
import { MockDashboardDataProvider } from './MockDashboardDataProvider';
import UIHarnessNav from './UIHarnessNav';

/**
 * UIHarnessWrapper - Main wrapper for UI Harness mode
 * 
 * Provides all mock contexts and harness navigation
 * IMPORTANT: This does NOT bypass authentication in production routes
 */
export default function UIHarnessWrapper({ children, layout, scenario = 'default' }) {
  return (
    <MockAuthProvider>
      <MockTenantProvider scenario={scenario}>
        <MockDashboardDataProvider scenario={scenario}>
          <UIHarnessNav />
          <div className="pt-12">
            {children}
          </div>
        </MockDashboardDataProvider>
      </MockTenantProvider>
    </MockAuthProvider>
  );
}
